<div class="dxp-row dxp-bg-initial">
    <div class="dxp-bg-initial dxp-col-md-12" id="requestDetailPanel">
        <dxp-flex-layout>
            <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="10px">
                <p class="search-panel-title">REQUEST DETAILS</p>
            </dxp-flex-layout-item>
        </dxp-flex-layout>
        <dxp-flex-layout *ngIf="this.loadDetails" #requestDetailsLayoutReferance>
            <dxp-flex-layout-item *ngFor="let request of this.arrangement" [slot]="request.column"
                [columnWidthSm]="request.columnWidth" [columnWidthLg]="request.columnWidth" padding-style-sm="15px 30px">
                <dxp-label class="label-text">{{request.fieldName}}</dxp-label>
                <p [class]="request.fieldStyle">{{request.fieldValue}}</p>
            </dxp-flex-layout-item>
        </dxp-flex-layout>
        <dxp-flex-layout *ngIf="this.loadDetails">
            <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12"
                padding-style-sm="10px 30px 20px 30px">
                <result-grid [columns]="this.columnDefsForRequestDetail" [export]=false [callback]="this.fetchResult"
                    [showSearchContent]="false" [pagination]="false" isModelGridViewWithSize="large" [autoFitEnable]="true"
                    #requestDetailGrid>
                </result-grid>
            </dxp-flex-layout-item>
        </dxp-flex-layout>
        <dxp-flex-layout *ngIf="this.showSupportingDetails">
            <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12"
                padding-style-sm="10px 30px 20px 30px">
                <result-grid [columns]="this.columnDefsForSupportingDetails" [export]=false [callback]="this.fetchSupportingDetailsResult"
                    [showSearchContent]="false" [pagination]="false" isModelGridViewWithSize="large"
                    [customTitle]="this.supportingDetailsTitle"
                    #supportingDetailsGrid>
                </result-grid>
            </dxp-flex-layout-item>
        </dxp-flex-layout>
        <dxp-flex-layout *ngIf="this.isOpenState">
            <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="15px 30px">
                <dxp-textarea [value]="this.notes" optional="true" placeholder="Enter comment" label="Note" rows="3" cols="40"
                    (changeText)="setNotes($event)" accessibility-text="Insert note" #notesTextAreaReference>
                </dxp-textarea>
                <p [ngClass]="(noteMaxLengthValid == 'invalid') ? 'validation-error' : 'label-text'">Maximum 50
                    characters are allowed</p>
                <p class="validation-error" *ngIf="isNoteRequired">Note is required.</p>
            </dxp-flex-layout-item>
        </dxp-flex-layout>
        <dxp-flex-layout *ngIf="!this.isOpenState && serverNotes">
            <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="15px 30px">
                <dxp-label class="label-text">Note</dxp-label>
                <p class="label-value">{{serverNotes}}</p>
            </dxp-flex-layout-item>
        </dxp-flex-layout>        
        <dxp-flex-layout *ngIf="this.isOpenState">
            <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="0px 0px 0px 30px">
                <span class="button-space" *ngIf="this.isChecker"><dxp-button type="primary" button-id="btnApprove" text="Approve" state="enabled" aria-label="Approve"
                    button-title="Approve" (click)="confirmAction(3)" [hidden]="!this.isChecker"></dxp-button></span>
                <span class="button-space" *ngIf="this.isChecker"><dxp-button type="secondary" button-id="btnReject" id="btnReject" text="Reject" state="enabled"
                    aria-label="Reject" button-title="Reject" (click)="confirmAction(4)"
                    [hidden]="!this.isChecker"></dxp-button></span>
                <dxp-button type="secondary" button-id="btnCancelRequest" id="btnCancel" text="Cancel" state="enabled"
                    aria-label="Cancel Request" button-title="CancelRequest" (click)="confirmAction(2)" [hidden]="!this.isMaker"></dxp-button>
            </dxp-flex-layout-item>
        </dxp-flex-layout>
    </div>
</div>

<confirmation-modal></confirmation-modal>